import React, { FunctionComponent, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ModalContent } from 'syf-component-library/ui/patterns/SlideInModal/subcomponents';
import Button from 'syf-component-library/ui/atoms/Button';
import { useAppDispatch } from '../../store/store';
import { detectDeviceType, setImagePath } from '../../utils/helpers';
import { getSessionId } from '../../store/sessionSlice';
import {
  capturePageLoadAnalytics,
  captureAnalyticsDataAttributes,
} from '../../utils/analytics/analyticsDispatchers';
import { getSessionTimeoutContent } from '../../store/contentSlice';
import { executeRefresh } from '../../store/refreshSlice';
import { executeLogout } from '../../store/logoutSlice';
import { SessionTimeoutInterface } from '../../interfaces/SessionTimeout.interface';
import { SESSION_EXPIRY_POPUP_EVENT } from '../../utils/analytics/analyticsEvents';
import {
  TIMEOUT_TIMER_INTERVAL,
  COUNTDOWN_TIME_TO_LOGOUT,
} from '../../utils/constants/timeoutConstants';

import './sessionTimeout.css';

const SessionTimeout: FunctionComponent<SessionTimeoutInterface> = ({
  handlePopupShowHide,
  sessionStartTime,
}: any) => {
  const {
    sessionTimeOutHeading,
    sessionTimeOutMessage,
    sessionSecondsText,
    staySignedInButton,
    signOutButton,
  }: any = useSelector(getSessionTimeoutContent);
  const sessionId = useSelector(getSessionId);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [countdownTime, setCountdownTime] = useState(null);
  const totalAvailableTime = TIMEOUT_TIMER_INTERVAL + COUNTDOWN_TIME_TO_LOGOUT;
  let timerInterval: any;

  useEffect(() => {
    capturePageLoadAnalytics(SESSION_EXPIRY_POPUP_EVENT);
  }, []);
  useEffect(() => {
    //timeout interval start only if the showTimeOutPrompt is true
    timerInterval = setInterval(() => {
      const millis = Date.now() - sessionStartTime;
      const timeElapsedSeconds = Math.floor(millis / 1000);
      const timeLeft: any = totalAvailableTime - timeElapsedSeconds;
      setCountdownTime(timeLeft);
      if (timeLeft <= 0) {
        clearInterval(timerInterval);
        handleSessionTimeout();
      }
    }, 1000);

    return () => {
      clearInterval(timerInterval);
    };
  }, []);

  const handleSessionTimeout = () => {
    handlePopupShowHide(false);
    dispatch(executeLogout());
    navigate('/session-timeout-error');
  };

  const handleLogout = (event: any) => {
    captureAnalyticsDataAttributes(event);
    handlePopupShowHide(false);
    dispatch(executeLogout());
    navigate('/thank-you');
  };
  const handleContinue = (event: any) => {
    captureAnalyticsDataAttributes(event);
    handlePopupShowHide(false);
    dispatch(executeRefresh(sessionId));
  };

  return (
    countdownTime && (
      <div className="pop-up" data-testid="session-timeout-popup">
        <ModalContent className="pop-up-container">
          <div className="session-timeout-image-wrapper">
            <img
              src={setImagePath('timeout-warning')}
              alt="timeout warning message"
            />
          </div>
          <span className="pop-up-title">{sessionTimeOutHeading}</span>
          <span className="pop-up-regular-text">
            {sessionTimeOutMessage}
            <strong> {countdownTime} </strong>
            {sessionSecondsText}
          </span>
          <div
            className="buttons-container"
            data-testid="session-timeout-buttons"
          >
            <Button
              className="button"
              onClick={handleContinue}
              buttonType="primary"
              data-testid="continueButton"
              data-type={detectDeviceType}
              data-reason="logoutPopUpModule"
              data-object="button"
              data-channel="staySignIn"
            >
              {staySignedInButton}
            </Button>
            <Button
              className="button"
              onClick={handleLogout}
              buttonType="ghost"
              data-testid="signOutButton"
              data-type={detectDeviceType}
              data-reason="logoutPopUpModule"
              data-object="button"
              data-channel="signOut"
            >
              {signOutButton}
            </Button>
          </div>
        </ModalContent>
      </div>
    )
  );
};

export default SessionTimeout;
